var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Hero',{attrs:{"title":"Creative Development & Digital Services","subtitle":"We build websites, web applications, media installations and help you measure your\n          success along the way."}}),_c('router-view'),_c('site-footer'),_c('contact-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }